module.exports = __webpack_public_path__ + "static/media/image6.3ad09aeb.webp";